import React from 'react'

import { useFiltersStore } from '../state/filtersStore'
import { useNavigationStore } from '../state/navigationStore'

const WizardCTA = () => {
  const setWizardOpen = useNavigationStore((state) => state.setWizardOpen)

  const selectFirstGuideFilter = useFiltersStore(
    (state) => state.selectFirstGuideFilter
  )
  const guideUsed = useFiltersStore((state) => state.guideUsed)

  return (
    <div className='wizard-cta'>
      <i className='wizard-cta__icon fa-solid fa-wand-magic-sparkles'></i>
      <h3 className='wizard-cta__title'>
        Get quick results with our Smart Guide
      </h3>
      <p className='wizard-cta__text'>
        Use our wizard to find the right heat pump and knowledge for your
        project
      </p>
      <button
        onClick={() => {
          selectFirstGuideFilter()
          setWizardOpen(true)
        }}
      >
        <span>{guideUsed ? 'Restart guide' : 'Start the Guide'}</span>
        <i className='fa-solid fa-arrow-right'></i>
      </button>
    </div>
  )
}

export { WizardCTA }
